export default __webpack_public_path__ + "static/media/lateral.378f77d4.svg";